import * as React from "react";

function SvgQuestionCircle(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg
      width="1em"
      height="1em"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M0 8a8 8 0 1016 0A8 8 0 000 8zm14 0A6 6 0 112 8a6 6 0 0112 0zm-7 2v-.5c0-1.218.424-1.818 1.4-2.55.524-.393.6-.501.6-.95a1 1 0 10-2 0H5a3 3 0 016 0c0 1.218-.424 1.818-1.4 2.55-.524.393-.6.501-.6.95v.5H7zm2 1.998a1 1 0 11-2 0 1 1 0 012 0z"
        fill="currentColor"
      />
    </svg>
  );
}

export default SvgQuestionCircle;
